import { memo } from "react";
import { t } from "@/i18n-js/instance";
import { Radio } from "@/react/components/shared/uikit/Radio";
import { Typography } from "@/react/components/shared/uikit/Typography";
import type { RadioOptionProps } from "./types";

const LOCALE_ROOT = "pricing_plans.plan_settings.plan_summary";

export const MonthlyRadioOption = memo<RadioOptionProps>(
  ({ id, interval, isSelected, onIntervalChange, plan }) => (
    <Radio
      id={id}
      name="billing-interval"
      label={
        <Typography.LabelSm weight="semibold">
          {t([LOCALE_ROOT, "monthly_billing"])}
        </Typography.LabelSm>
      }
      value={interval}
      description={
        <Typography.BodySm weight="normal">
          {t([LOCALE_ROOT, "plan_monthly_amount"], {
            amount: plan?.display_base_monthly_amount,
          })}
        </Typography.BodySm>
      }
      defaultChecked={isSelected}
      onChange={() => onIntervalChange(interval)}
    />
  ),
);

MonthlyRadioOption.displayName = "MonthlyRadioOption";
